/**
 * Armenian Belot — «листок» матча: строки по событию ROUND_SCORED.
 * Индексы команд 0 и 1 как в движке; «мы/они» — относительно команды героя/зрителя.
 *
 * @module game/belotArmenian/scoreSheet
 */

/**
 * @param {0|1} heroTeam — `teamOfSeat(ваше место)`
 * @param {[number, number]} delta — `payload.delta` из ROUND_SCORED
 * @param {[number, number]} teamScoresAfter — `state.teamScores` после раунда
 * @param {number} roundOrdinal — номер записанного раунда (обычно `state.roundIndex` после подсчёта)
 * @returns {{ roundOrdinal: number, deltaUs: number, deltaThem: number, cumUs: number, cumThem: number }}
 */
function mapRoundScoredToSheetRow(heroTeam, delta, teamScoresAfter, roundOrdinal) {
  const d0 = Number(delta[0]) || 0;
  const d1 = Number(delta[1]) || 0;
  const s0 = Number(teamScoresAfter[0]) || 0;
  const s1 = Number(teamScoresAfter[1]) || 0;
  const deltaUs = heroTeam === 0 ? d0 : d1;
  const deltaThem = heroTeam === 0 ? d1 : d0;
  const cumUs = heroTeam === 0 ? s0 : s1;
  const cumThem = heroTeam === 0 ? s1 : s0;
  return { roundOrdinal, deltaUs, deltaThem, cumUs, cumThem };
}

/**
 * Сырые строки из снапшота комнаты → строки «мы / они» для текущего места.
 * @param {0|1|null|undefined} viewerTeam
 * @param {Array<{ roundIndex?: number, delta?: number[], teamScoresAfter?: number[] }>|null|undefined} raw
 * @returns {Array<{ roundOrdinal: number, deltaUs: number, deltaThem: number, cumUs: number, cumThem: number }>}
 */
function mapSnapshotSheetToHeroRows(viewerTeam, raw) {
  if (viewerTeam !== 0 && viewerTeam !== 1) return [];
  if (!Array.isArray(raw)) return [];
  /** @type {Array<{ roundOrdinal: number, deltaUs: number, deltaThem: number, cumUs: number, cumThem: number }>} */
  const out = [];
  for (const r of raw) {
    const d = r?.delta;
    const s = r?.teamScoresAfter;
    const ri = Number(r?.roundIndex);
    if (!Array.isArray(d) || d.length < 2 || !Array.isArray(s) || s.length < 2) continue;
    if (!Number.isFinite(ri) || ri < 1) continue;
    out.push(
      mapRoundScoredToSheetRow(
        viewerTeam,
        /** @type {[number, number]} */ ([Number(d[0]) || 0, Number(d[1]) || 0]),
        /** @type {[number, number]} */ ([Number(s[0]) || 0, Number(s[1]) || 0]),
        ri,
      ),
    );
  }
  return out;
}

module.exports = {
  mapRoundScoredToSheetRow,
  mapSnapshotSheetToHeroRows,
};
